import type { ClientNewsItemChangeRequest } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useQueryClient } from '@tanstack/react-query';

import { POST_MUTATION_KEYS } from '@/features/api/constants/mutation';
import { useGrapevinePostEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevinePostEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForChangedPost } from '@/features/api/utils/postCaches';

export const useChangeNewsItem = () => {
  const queryClient = useQueryClient();
  const api = useGrapevinePostEventsApi();

  return useApiMutation({
    mutationKey: [POST_MUTATION_KEYS.CHANGE],
    mutationFn: (clientNewsItemChangeRequest: ClientNewsItemChangeRequest) =>
      api.onNewsItemChangeRequest({ clientNewsItemChangeRequest }),
    onSuccess: ({ post }) =>
      invalidatePostCachesForChangedPost(queryClient, post)
  });
};
